import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import {reducer as toastrReducer} from 'react-redux-toastr';
import {reducer as formReducer} from  'redux-form';
import UserReducer from "./UserReducer";
import DashboardReducer from "./DashboardReducer";
import VideoReducer from './VideoReducer';
import Story from "./StoryReducer";

const rootReducer = combineReducers({   
   form           : formReducer,
   toastr         : toastrReducer,
   auth           : AuthReducer,
   user           : UserReducer,
   dashboard      : DashboardReducer,
   video          : VideoReducer,
   story          : Story
  
});

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.js